import type { JSX } from 'react';

interface LogoProps {
  size?: number;
  className?: string;
  title?: string;
}

/**
 * Nerdy Paradise mark — the canonical platform anchor.
 *
 * Italic Fraunces lowercase "np" centred on a 135° gradient square
 * (indigo `#3E4BCC` → coral `#FF6B4A`). This is the design captured in
 * `tmp/platform-mockups/logos.html` and used as the favicon / PWA app
 * icon — the brand stays stable across every header, browser tab, and
 * homescreen install.
 *
 * Per the mockup brief: "the anchor. Italic serif on a gradient
 * square. Stable across every app header and every browser tab."
 */
export function NerdyParadiseLogo({
  size = 48,
  className,
  title = 'Nerdy Paradise',
}: LogoProps): JSX.Element {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      className={className}
      role="img"
      aria-label={title}
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{title}</title>
      <defs>
        <linearGradient id="np-mark" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#3E4BCC" />
          <stop offset="100%" stopColor="#FF6B4A" />
        </linearGradient>
      </defs>
      <rect x="5" y="5" width="90" height="90" rx="24" fill="url(#np-mark)" />
      <text
        x="50"
        y="67"
        fontFamily="Fraunces, Georgia, serif"
        fontSize="44"
        fontStyle="italic"
        fontWeight="500"
        fill="white"
        textAnchor="middle"
      >
        np
      </text>
    </svg>
  );
}
